import {intlShape, utils} from '@wallaby-ui/core';
import classNames from 'classnames';
import {isNil, isString} from 'lodash';
import PropTypes from 'prop-types';
import * as React from 'react';
import {injectIntl} from 'react-intl';

import styles from './StatusIconFormatter.less';

class StatusIconFormatter extends React.PureComponent {
  render() {
    const {intl, value} = this.props;
    let ownValue;
    if (!isNil(value)) {
      if (value.value) {
        ownValue = JSON.parse(value.value);
      } else if (isString(value)) {
        ownValue = JSON.parse(value);
      }
    }
    if (!isNil(ownValue)) {
      if (ownValue.status) {
        const label = ownValue.tooltip
          ? utils.TranslateUtils.translate(ownValue.tooltip, intl)
          : undefined;
        return (
          <div className={styles.dlStatusIconFormatter}>
            <i
              title={label}
              className={classNames('fas fa-exclamation', styles.dlStatusWrong)}
            />
          </div>
        );
      }
    }
    return '';
  }
}

StatusIconFormatter.displayName = 'StatusIconFormatter';

StatusIconFormatter.propTypes = {
  intl: intlShape.isRequired,
  value: PropTypes.oneOfType([
    PropTypes.objectOf(PropTypes.any),
    PropTypes.string,
  ]),
};

StatusIconFormatter.defaultProps = {
  value: undefined,
};

export default injectIntl(StatusIconFormatter);
